<template>
  <div class="section-dark skills" id="skills">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-12 about-me">
          <h1 class="title has-text-centered section-title">{{ $t('message.skills.head') }}</h1>
        </div>
        <template v-for="skill_topic in $t('message.skills.skills_by_topic')">
          <div class="column is-12 skill-topic-headline" :key="skill_topic.topic" @click="toggleSkill($event, 'topic-' + skill_topic.topic)">
            <div class="subtitle hr-sect"><i class="fas fa-caret-down" style="font-size:1.2em; padding-right: 5px"></i>{{ skill_topic.topic }}</div>
          </div>
          <div
            :class="'column is-6 topic-' + skill_topic.topic"
            data-aos="fade-in"
            data-aos-easing="linear"
            v-for="skill in skill_topic.skills"
            :key="skill.area"
          >
            <div style="margin-left: 15px; margin-right: 15px">
              <b-tooltip :label="skill.explanation"
                type="is-light"
                animated
                size="is-large"
                multilined
                v-if="'explanation' in skill"
                >
                  <h1 class="skills-head skills-head-with-tooltip" @mouseover="ensureVisibility($event)">
                    {{ skill.area }}
                  </h1>
              </b-tooltip>
              <h1 class="skills-head" v-if="!('explanation' in skill)">{{ skill.area }}</h1>
              <progress class="progress" :value="skill.value" max="100"></progress>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  var UID = {
    _current: 0,
    getNew: function(){
      this._current++;
      return this._current;
    }
  };

  HTMLElement.prototype.pseudoStyle = function(element,prop,value){
    var _this = this;
    var _sheetId = "pseudoStyles";
    var _head = document.head || document.getElementsByTagName('head')[0];
    var _sheet = document.getElementById(_sheetId) || document.createElement('style');
    _sheet.id = _sheetId;
    var className = "pseudoStyle" + UID.getNew();

    _this.className +=  " "+className;

    _sheet.innerHTML += " ."+className+":"+element+"{"+prop+":"+value+"}";
    _head.appendChild(_sheet);
    return this;
  };

export default {
  name: 'Skills',
  methods: {
    toggleSkill(event, skillClass) {
      const clickedTopic = event.target.closest('.skill-topic-headline');
      console.log(clickedTopic);
      const iconEl = event.target.querySelector("i");
      iconEl.classList.toggle("fa-caret-down");
      iconEl.classList.toggle("fa-caret-right");
      const skills = clickedTopic.parentNode.querySelectorAll('.' + skillClass);
      skills.forEach((item) => {
        item.style.display = item.style.display != 'none' ? 'none' : '';
      });
    },
    ensureVisibility(event) {
      event.target.parentElement.pseudoStyle('after', 'left', event.target.layerX + 'px !important');
      //console.log(event.target.parentElement);
    }
  }
}
</script>

<style>
.hr-sect {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 0.35);
  margin: 8px 0px;
  cursor: pointer;
}
.hr-sect::before,
.hr-sect::after {
  content: "";
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.35);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 8px;
}


.b-tooltip.is-top::before, .b-tooltip.is-top::after {
    left: calc(12%) !important;
    -webkit-transform: translateX(-5%) !important;
    transform: translateX(-5%) !important;
}

.b-tooltip.is-multiline::after {
  text-align: left !important;
}
.skills-head {
  padding-bottom: 2px;
}

.skills-head-with-tooltip:after {
  content: '?';
  display: inline-block;
  font-family: sans-serif;
  /* font-weight: bold; */
  text-align: center;
  width: 2.3ex;
  height: 2.3ex;
  font-size: 1.4ex;
  line-height: 1.8ex;
  border-radius: 1.2ex;
  margin-left: 5px;
  padding: 1px;
  color: white;
  background: #4c567b;
  border: 1px solid #43485c;
  text-decoration: none;
}
</style>
